<template>
	<vx-card>
		<div slot="no-body">
			<vs-chip v-if="beta" color="dark" style="position: absolute; top: 5px; left: 5px">
				Béta
			</vs-chip>
			<vs-chip :color="this.getTypeColor()" style="position: absolute; top: 5px; right: 5px">
				{{ this.getTypeName() }}
			</vs-chip>
			<img v-if="image" :src="image" alt="content-img" class="responsive card-img-top">
			<div v-else class="responsive card-img-top" style="background: #f5f5f5; display: flex; align-items: center; justify-content: center; min-height: 200px; color: #999;">
				Geen afbeelding beschikbaar
			</div>
		</div>
		<h5 class="mb-2">{{ name }}</h5>
		<vx-tooltip :text="description">
			<p class="text-grey"
			   style="display: block; height: 5.4em; line-height: 1.8em; text-overflow: fade; overflow: hidden; word-wrap: break-word">
				{{ description }}
			</p>
		</vx-tooltip>
		<div class="flex justify-end flex-wrap">
			<router-link :to="{name: urlName}">
				<vs-button class="mt-4 w-full shadow-sm" type="border" color="primary">Instellen</vs-button>
			</router-link>
		</div>
	</vx-card>
</template>

<script>

export default {
	name: 'module-card',
	props: {
		type: {
			type: String,
			required: true,
		},
		image: {
			required: false,
		},
		name: {
			type: String,
			required: true
		},
		description: {
			type: String,
			required: true
		},
		urlName: {
			type: String,
			required: true
		},
		beta: {
			type: Boolean,
		},
		price: {
			type: String,
			required: false,
		},
	},
	methods: {
		getTypeColor() {
			switch (this.type) {
				case 'accounting':
					return 'success';
				case 'webshop':
					return 'dark';
				case 'shipping':
					return 'warning';
				case 'printing':
					return 'danger';
				case 'discount':
					return 'success';
				case 'inventory':
					return 'gray';
			}
		},
		getTypeName() {
			switch (this.type) {
				case 'accounting':
					return 'Boekhouding';
				case 'webshop':
					return 'Webshop';
				case 'shipping':
					return 'Verzending';
				case 'printing':
					return 'Printen';
				case 'discount':
					return 'Korting';
				case 'inventory':
					return 'Voorraad';
			}
		}
	}
}
</script>